<div class="list-group">
  <label
    class="list-group-item d-flex align-items-center justify-content-between"
    *ngFor="let bucket of facet['buckets']; let i = index; trackBy: trackBucket"
    [ngClass]="{ 'is-timeout': isTimeout(bucket) }"
  >
    <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
      <input
        class="form-check-input me-2"
        type="checkbox"
        [checked]="bucket.checked"
        (change)="check(bucket)"
        [attr.aria-label]="bucket.label"
        [disabled]="isTimeout(bucket)"
      />

      <!-- Label text; hover shows timeout info when applicable -->
      <span
        class="text-truncate truncate-label"
        [attr.title]="isTimeout(bucket) ? timeoutText(bucket) : bucket.label"
      >
        {{ bucket.label }}
      </span>
    </div>

    <!-- Badge: X when timed out, otherwise the count -->
    <span
      class="badge ms-2"
      [ngClass]="{ 'badge-timeout': isTimeout(bucket) }"
      [attr.aria-label]="badgeAria(bucket)"
      [attr.title]="isTimeout(bucket) ? timeoutText(bucket) : null"
      [attr.role]="isTimeout(bucket) ? 'img' : null"
    >
      <ng-container *ngIf="isTimeout(bucket); else countTpl">X</ng-container>
      <ng-template #countTpl>{{ bucket.count }}</ng-template>
    </span>
  </label>

  <div class="list-group-item d-flex justify-content-between align-items-center pt-2 clear-all-item">
    <!-- LEFT: Refresh Results (only when a timed-out provider exists) -->
    <a
      *ngIf="canRefresh"
      href="javascript:void(0);"
      class="refresh-link"
      [class.disabled]="isRefreshing || isLoading"
      [attr.aria-disabled]="(isRefreshing || isLoading) ? 'true' : 'false'"
      (click)="refresh()"
    >
      <ng-container *ngIf="!isRefreshing; else refreshingTpl">REFRESH RESULTS</ng-container>
      <ng-template #refreshingTpl>REFRESHING...</ng-template>
    </a>

    <!-- RIGHT: Clear All (always visible) -->
    <a href="javascript:void(0);" class="clear-all-link" (click)="clear()">CLEAR ALL</a>
  </div>
</div>
